import { render } from "./ActivityModelOne.vue?vue&type=template&id=42010fd4"
import script from "./ActivityModelOne.vue?vue&type=script&lang=js"
export * from "./ActivityModelOne.vue?vue&type=script&lang=js"

import "./ActivityModelOne.vue?vue&type=style&index=0&id=42010fd4&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__